import React from "react";
import Lottie from "lottie-react";
import arrowAnimation from "../../lottie/arrow-lottie/Arrow_Lottie.json";

function Common_Login_Button({ text }) {
  return (
    <button type="submit" className="customer-action-btn">
      <span className="customer-btn-text">{text}</span>

      <div className="customer-lottie-circle">
        <Lottie
          animationData={arrowAnimation}
          loop={true}
          style={{ width: "20px" }}
        />
      </div>
    </button>
  );
}

export default Common_Login_Button;
